(() => {
  if (window.primeHeroMotion) return;
  window.primeHeroMotion = true;
  const instances = new Map();
  function mount(root) {
    root.querySelectorAll('[data-hero-motion]').forEach((hero) => {
      const button = hero.querySelector('.pw-hero__motion-toggle');
      if (!button || instances.has(hero)) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false;
      let visible = false;
      const sync = () => {
        hero.classList.toggle('pw-hero--playing', visible && !document.hidden && !paused && !reduced.matches);
        hero.querySelector('.pw-hero__motion-controls').hidden = reduced.matches;
        button.textContent = paused ? 'Play colour animation' : 'Pause colour animation';
        button.setAttribute('aria-pressed', String(paused));
      };
      const toggle = () => { paused = !paused; sync(); };
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }, { threshold: 0.05 });
      hero.classList.add('pw-hero--motion-ready');
      observer.observe(hero);
      button.addEventListener('click', toggle);
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', sync);
      instances.set(hero, () => {
        observer.disconnect();
        button.removeEventListener('click', toggle);
        document.removeEventListener('visibilitychange', sync);
        reduced.removeEventListener('change', sync);
      });
      sync();
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [hero, dispose] of instances) {
      if (event.target.contains(hero)) { dispose(); instances.delete(hero); }
    }
  });
})();
